// import React, { useState, useEffect } from "react";
// import Grid from "@mui/material/Unstable_Grid2";
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Paper,
//   Stack,
//   Divider,
//   IconButton,
//   Card,
//   CardContent,
//   Alert,
//   Chip,
//   CircularProgress,
//   alpha,
//   useTheme,
//   Fade,
//   Zoom,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Badge,
//   Snackbar,
//   Tooltip,
//   Fab,
// } from "@mui/material";
// import {
//   AutoStories,
//   FormatListBulleted,
//   Image,
//   Lightbulb,
//   ContentCopy,
//   Download,
//   Save,
//   CheckCircle,
//   Language,
//   EditNote,
//   Psychology,
//   Palette,
//   DesignServices,
//   Dashboard,
//   Book,
//   Star,
//   Bolt,
//   RocketLaunch,
//   Share,
//   Close,
//   Fullscreen,
//   Visibility,
//   Delete,
//   FileDownload,
//   FileCopy,
//   IosShare,
//   SaveAlt,
//   History,
//   Check,
//   Expand,
//   Launch,
//   ArrowDownward,
// } from "@mui/icons-material";
// import MuiAlert from "@mui/material/Alert";
// import { Breadcrumbs, Link } from "@mui/material";
// import { Home, ChevronRight } from "@mui/icons-material";
// import newBlogService from "../services/new_blogsServices";

// const AIBookWriting = () => {
//   const [activeGenerator, setActiveGenerator] = useState("idea");
//   const [language, setLanguage] = useState("english");
//   const [bookType, setBookType] = useState("");
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [generatedContent, setGeneratedContent] = useState("");
//   const [editedContent, setEditedContent] = useState("");
//   const [savedContents, setSavedContents] = useState([]);
//   const [openContentDialog, setOpenContentDialog] = useState(false);
//   const [openSavedDialog, setOpenSavedDialog] = useState(false);
//   const [notification, setNotification] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const theme = useTheme();
//   const getContent = (res) => res?.data?.content || null;

//   useEffect(() => {
//     const saved = localStorage.getItem("aiBookSavedContents");
//     if (saved) {
//       setSavedContents(JSON.parse(saved));
//     }
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("aiBookSavedContents", JSON.stringify(savedContents));
//   }, [savedContents]);

//   useEffect(() => {
//     setEditedContent(generatedContent);
//   }, [generatedContent]);

//   const generators = [
//     {
//       id: "idea",
//       label: "Book Idea Generator",
//       description: "Generate unique book concepts",
//       icon: <Lightbulb />,
//       color: "warning",
//     },
//     {
//       id: "outline",
//       label: "Book Outline Generator",
//       description: "Create chapter structures",
//       icon: <FormatListBulleted />,
//       color: "info",
//     },
//     {
//       id: "cover",
//       label: "Book Cover Ideas",
//       description: "Design book cover concepts",
//       icon: <Palette />,
//       color: "success",
//     },
//     {
//       id: "summary",
//       label: "Book Summary Generator",
//       description: "Craft summaries and synopses",
//       icon: <DesignServices />,
//       color: "secondary",
//     },
//   ];

//   const languages = [
//     { value: "english", label: "English" },
//     { value: "tamil", label: "Tamil" },
//     { value: "arabic", label: "Arabic" },
//     { value: "spanish", label: "Spanish" },
//     { value: "french", label: "French" },
//     { value: "german", label: "German" },
//     { value: "japanese", label: "Japanese" },
//     { value: "korean", label: "Korean" },
//   ];

//   const bookTypesData = [
//     { value: "horror", label: "Horror" },
//     { value: "fantasy", label: "Fantasy" },
//     { value: "romance", label: "Romance" },
//     { value: "science", label: "Science Fiction" },
//     { value: "thriller", label: "Thriller" },
//     { value: "crime", label: "Crime" },
//     { value: "action", label: "Action" },
//     { value: "historical", label: "Historical" },
//   ];

//   const showNotification = (message, severity = "success") => {
//     setNotification({
//       open: true,
//       message,
//       severity,
//     });
//   };
//   const generateBookIdeaFromAPI = async () => {
//     if (!formData.bookAbout || !bookType || !formData.category) {
//       showNotification("Please fill all required fields!", "warning");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         language: language.charAt(0).toUpperCase() + language.slice(1),
//         book_genre: bookType,
//         category: formData.category,
//         book_about: formData.bookAbout,
//         tone: "Creative",
//       };

//       console.log("🚀 BOOK IDEA PAYLOAD:", payload);

//       const res = await newBlogService.generateBookIdea(payload);

//       const content = getContent(res);

//     if (!content) {
//       showNotification(
//         res?.data?.message || "Failed to get content from server",
//         "error"
//       );
//       return;
//     }

//     setGeneratedContent(content);
//     setEditedContent(content);
//     showNotification("Book idea generated successfully!", "success");

//   } catch (err) {
//       console.error(err);
//       showNotification("Failed to generate book idea", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const generateBookCoverFromAPI = async () => {
//     if (!formData.title || !formData.author || !formData.summary || !bookType) {
//       showNotification("Please fill all required fields!", "warning");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         language: language.charAt(0).toUpperCase() + language.slice(1),
//         book_genre: bookType,
//         chapters: formData.chapters || "12",
//         book_title: formData.title,
//         author_name: formData.author,
//         subtitle: formData.subtitle || "",
//         brief_summary: formData.summary,
//         tone: "Creative",
//       };

//       console.log("🚀 BOOK COVER PAYLOAD:", payload);

//       const res = await newBlogService.generateBookCoverIdeas(payload);

//      const content = getContent(res);

//     if (!content) {
//       showNotification(
//         res?.data?.message || "Failed to get content from server",
//         "error"
//       );
//       return;
//     }

//     setGeneratedContent(content);
//     setEditedContent(content);
//     showNotification("Book idea generated successfully!", "success");

//   }  catch (err) {
//       console.error(err);
//       showNotification("Failed to generate book cover ideas", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGeneratorClick = (generatorId) => {
//     setActiveGenerator(generatorId);
//     setFormData({});
//     setGeneratedContent("");
//     setEditedContent("");
//   };

//   const handleFormChange = (field) => (event) => {
//     setFormData({ ...formData, [field]: event.target.value });
//   };

//   const generateBookOutlineFromAPI = async () => {
//     if (!formData.title || !formData.chapters || !bookType) {
//       showNotification("Please fill all required fields!", "warning");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         language: language.charAt(0).toUpperCase() + language.slice(1),
//         book_genre: bookType,
//         chapters: formData.chapters,
//         book_title: formData.title,
//         target_audience: formData.audience || "General readers",
//         tone: "Creative",
//       };

//       console.log("🚀 BOOK OUTLINE PAYLOAD:", payload);

//       const res = await newBlogService.generateBookOutline(payload);

//       console.log("✅ BOOK OUTLINE RESPONSE:", res);

//      const content = getContent(res);

//     if (!content) {
//       showNotification(
//         res?.data?.message || "Failed to get content from server",
//         "error"
//       );
//       return;
//     }

//     setGeneratedContent(content);
//     setEditedContent(content);
//     showNotification("Book idea generated successfully!", "success");

//   } catch (err) {
//       console.error(err);
//       showNotification("Failed to generate book outline", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const generateBookSummaryFromAPI = async () => {
//     if (!formData.bookAbout || !bookType) {
//       showNotification("Please fill all required fields!", "warning");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         language: language.charAt(0).toUpperCase() + language.slice(1),
//         book_genre: bookType,
//         book_about: formData.bookAbout,
//         tone_of_writing: formData.tone || "Dramatic",
//       };

//       console.log("🚀 BOOK SUMMARY PAYLOAD:", payload);

//       const res = await newBlogService.generateBookSummary(payload);

//      const content = getContent(res);

//     if (!content) {
//       showNotification(
//         res?.data?.message || "Failed to get content from server",
//         "error"
//       );
//       return;
//     }

//     setGeneratedContent(content);
//     setEditedContent(content);
//     showNotification("Book idea generated successfully!", "success");

//   }  catch (err) {
//       console.error(err);
//       showNotification("Failed to generate book summary", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGenerate = async (e) => {
//     if (e) e.preventDefault();

//     if (activeGenerator === "idea") {
//       await generateBookIdeaFromAPI();
//     } else if (activeGenerator === "outline") {
//       await generateBookOutlineFromAPI();
//     } else if (activeGenerator === "cover") {
//       await generateBookCoverFromAPI();
//     } else if (activeGenerator === "summary") {
//       await generateBookSummaryFromAPI();
//     } else {
//       showNotification("API not connected for this generator yet", "info");
//     }
//   };

  
//   const handleSave = () => {
//     if (!editedContent.trim()) {
//       showNotification("No content to save!", "warning");
//       return;
//     }

//     const newContent = {
//       id: Date.now(),
//       title:
//         generators.find((g) => g.id === activeGenerator)?.label || "Untitled",
//       content: editedContent,
//       generator: activeGenerator,
//       language,
//       genre: bookType,
//       timestamp: new Date().toLocaleString(),
//       preview: editedContent.substring(0, 100) + "...",
//     };

//     const updatedContents = [newContent, ...savedContents];
//     setSavedContents(updatedContents);
//     showNotification("Content saved successfully!", "success");
//   };

//   const handleDownload = () => {
//     if (!editedContent.trim()) {
//       showNotification("No content to download!", "warning");
//       return;
//     }

//     const element = document.createElement("a");
//     const file = new Blob([editedContent], { type: "text/plain" });
//     element.href = URL.createObjectURL(file);
//     element.download = `ai-book-${activeGenerator}-${Date.now()}.txt`;
//     document.body.appendChild(element);
//     element.click();
//     document.body.removeChild(element);
//     showNotification("Content downloaded!", "success");
//   };

//   const handleCopy = () => {
//     if (!editedContent.trim()) {
//       showNotification("No content to copy!", "warning");
//       return;
//     }

//     navigator.clipboard
//       .writeText(editedContent)
//       .then(() => showNotification("Content copied to clipboard!", "success"))
//       .catch(() => showNotification("Failed to copy content!", "error"));
//   };

//   const handleShare = () => {
//     if (!editedContent.trim()) {
//       showNotification("No content to share!", "warning");
//       return;
//     }

//     if (navigator.share) {
//       navigator
//         .share({
//           title: `AI Generated Book ${generators.find((g) => g.id === activeGenerator)?.label}`,
//           text: editedContent.substring(0, 100),
//           url: window.location.href,
//         })
//         .then(() => showNotification("Content shared successfully!", "success"))
//         .catch(() => showNotification("Share cancelled!", "info"));
//     } else {
//       handleCopy();
//     }
//   };

//   const handleExport = () => {
//     if (!editedContent.trim()) {
//       showNotification("No content to export!", "warning");
//       return;
//     }

//     const data = {
//       title: generators.find((g) => g.id === activeGenerator)?.label,
//       content: editedContent,
//       metadata: {
//         generator: activeGenerator,
//         language,
//         genre: bookType,
//         timestamp: new Date().toISOString(),
//       },
//     };

//     const element = document.createElement("a");
//     const file = new Blob([JSON.stringify(data, null, 2)], {
//       type: "application/json",
//     });
//     element.href = URL.createObjectURL(file);
//     element.download = `ai-book-export-${Date.now()}.json`;
//     document.body.appendChild(element);
//     element.click();
//     document.body.removeChild(element);
//     showNotification("Content exported as JSON!", "success");
//   };

//   const handleDeleteSaved = (id) => {
//     const updatedContents = savedContents.filter(
//       (content) => content.id !== id,
//     );
//     setSavedContents(updatedContents);
//     showNotification("Content deleted!", "success");
//   };

//   const handleViewSaved = (content) => {
//     setGeneratedContent(content.content);
//     setEditedContent(content.content);
//     setOpenSavedDialog(false);
//     showNotification("Content loaded from saved items!", "info");
//   };

//   const renderFormFields = () => {
//     switch (activeGenerator) {
//       case "idea":
//         return (
//           <>
//             <Grid xs={12}>
//               <TextField
//                 fullWidth
//                 label="What is your book about?"
//                 placeholder="Describe your book idea..."
//                 multiline
//                 rows={2}
//                 value={formData.bookAbout || ""}
//                 onChange={handleFormChange("bookAbout")}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Category</InputLabel>
//                 <Select
//                   value={formData.category || ""}
//                   label="Category"
//                   onChange={handleFormChange("category")}
//                   required
//                   sx={{ borderRadius: 1 }}
//                 >
//                   <MenuItem value="fiction">Fiction</MenuItem>
//                   <MenuItem value="non-fiction">Non-Fiction</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </>
//         );

//       case "outline":
//         return (
//           <>
//             <Grid xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 type="number"
//                 label="Chapters"
//                 value={formData.chapters || ""}
//                 onChange={handleFormChange("chapters")}
//                 InputProps={{
//                   inputProps: { min: 1, max: 50 },
//                 }}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 label="Book Title"
//                 value={formData.title || ""}
//                 onChange={handleFormChange("title")}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 label="Target Audience"
//                 value={formData.audience || ""}
//                 onChange={handleFormChange("audience")}
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//           </>
//         );

//       case "cover":
//         return (
//           <>
//             <Grid xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Author's Name"
//                 value={formData.author || ""}
//                 onChange={handleFormChange("author")}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Book Title"
//                 value={formData.title || ""}
//                 onChange={handleFormChange("title")}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12}>
//               <TextField
//                 fullWidth
//                 label="Subtitle (Optional)"
//                 value={formData.subtitle || ""}
//                 onChange={handleFormChange("subtitle")}
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12}>
//               <TextField
//                 fullWidth
//                 label="Brief Summary"
//                 multiline
//                 rows={2}
//                 value={formData.summary || ""}
//                 onChange={handleFormChange("summary")}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//           </>
//         );

//       case "summary":
//         return (
//           <>
//             <Grid xs={12}>
//               <TextField
//                 fullWidth
//                 label="What is your book about?"
//                 placeholder="Describe your book idea..."
//                 multiline
//                 rows={2}
//                 value={formData.bookAbout || ""}
//                 onChange={handleFormChange("bookAbout")}
//                 required
//                 size="small"
//                 sx={{ borderRadius: 1 }}
//               />
//             </Grid>
//             <Grid xs={12}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Tone of Writing</InputLabel>
//                 <Select
//                   value={formData.tone || ""}
//                   label="Tone of Writing"
//                   onChange={handleFormChange("tone")}
//                   sx={{ borderRadius: 1 }}
//                 >
//                   <MenuItem value="formal">Formal</MenuItem>
//                   <MenuItem value="casual">Casual</MenuItem>
//                   <MenuItem value="humorous">Humorous</MenuItem>
//                   <MenuItem value="dramatic">Dramatic</MenuItem>
//                   <MenuItem value="poetic">Poetic</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         backgroundColor: theme.palette.grey[50],
//         backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.05)} 0%, ${alpha(theme.palette.secondary.light, 0.05)} 100%)`,
//         py: 2,
//       }}
//     >
//       <Container maxWidth="lg" sx={{ py: 1 }}>
//         <Box sx={{ mb: 2 }}>
//           <Breadcrumbs
//             separator={
//               <ChevronRight
//                 fontSize="small"
//                 sx={{ color: theme.palette.primary.main }}
//               />
//             }
//             aria-label="breadcrumb"
//           >
//             <Link
//               href="/blogpage"
//               underline="hover"
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 fontSize: "0.875rem",
//                 color: theme.palette.primary.main,
//                 fontWeight: 500,
//                 "&:hover": {
//                   color: theme.palette.primary.dark,
//                 },
//               }}
//             >
//               <Home sx={{ mr: 0.5, fontSize: 16 }} />
//               Blog Page
//             </Link>

//             <Typography
//               sx={{
//                 fontSize: "0.875rem",
//                 fontWeight: 600,
//                 background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 backgroundClip: "text",
//               }}
//             >
//               AI Book Writing Assistant
//             </Typography>
//           </Breadcrumbs>
//         </Box>

//         {/* Compact Header */}
//         <Box sx={{ textAlign: "center", mb: 3 }}>
//           <Stack direction="row" spacing={1} justifyContent="center" mb={1}>
//             <Box
//               sx={{
//                 p: 1,
//                 borderRadius: 2,
//                 background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 color: "white",
//               }}
//             >
//               <AutoStories sx={{ fontSize: 40 }} />
//             </Box>
//           </Stack>
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             sx={{
//               fontWeight: 700,
//               color: theme.palette.primary.dark,
//               fontSize: { xs: "1.75rem", md: "2.25rem" },
//               mb: 0.5,
//             }}
//           >
//             AI Book Writing Assistant
//           </Typography>
//           <Typography
//             variant="subtitle1"
//             sx={{
//               color: theme.palette.text.secondary,
//               mb: 2,
//               fontWeight: 400,
//             }}
//           >
//             Generate, save, and export your book ideas with AI
//           </Typography>
//         </Box>

//         {/* Main Content Card */}
//         <Paper
//           elevation={2}
//           sx={{
//             p: { xs: 2, md: 3 },
//             borderRadius: 3,
//             background: "white",
//             mb: 3,
//           }}
//         >
//           {/* Generator Selection */}
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{
//               mb: 2,
//               fontWeight: 600,
//               color: theme.palette.primary.dark,
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             }}
//           >
//             <Dashboard sx={{ fontSize: 20 }} />
//             Choose Your AI Generator
//           </Typography>

//           <Grid container spacing={2} sx={{ mb: 4 }}>
//             {generators.map((gen) => (
//               <Grid xs={12} sm={6} md={3} key={gen.id}>
//                 <Card
//                   onClick={() => handleGeneratorClick(gen.id)}
//                   sx={{
//                     cursor: "pointer",
//                     height: "100%",
//                     transition: "all 0.2s",
//                     border: activeGenerator === gen.id ? 2 : 1,
//                     borderColor:
//                       activeGenerator === gen.id
//                         ? `${gen.color}.main`
//                         : "divider",
//                     "&:hover": {
//                       transform: "translateY(-2px)",
//                       boxShadow: 2,
//                     },
//                   }}
//                   elevation={activeGenerator === gen.id ? 1 : 0}
//                 >
//                   <CardContent sx={{ textAlign: "center", py: 2, px: 1 }}>
//                     <Box
//                       sx={{
//                         color: `${gen.color}.main`,
//                         mb: 1,
//                         "& .MuiSvgIcon-root": { fontSize: 28 },
//                       }}
//                     >
//                       {gen.icon}
//                     </Box>
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       gutterBottom
//                     >
//                       {gen.label}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {gen.description}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>

//           {/* Compact Settings Row */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid xs={12} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>
//                   <Stack direction="row" spacing={0.5} alignItems="center">
//                     <Language sx={{ fontSize: 16 }} />
//                     <Typography variant="caption">Language</Typography>
//                   </Stack>
//                 </InputLabel>
//                 <Select
//                   value={language}
//                   label="Language"
//                   onChange={(e) => setLanguage(e.target.value)}
//                   size="small"
//                   sx={{ borderRadius: 1 }}
//                 >
//                   {languages.map((lang) => (
//                     <MenuItem key={lang.value} value={lang.value}>
//                       {lang.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid xs={12} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>
//                   <Stack direction="row" spacing={0.5} alignItems="center">
//                     <EditNote sx={{ fontSize: 16 }} />
//                     <Typography variant="caption">Book Genre</Typography>
//                   </Stack>
//                 </InputLabel>
//                 <Select
//                   value={bookType}
//                   label="Book Genre"
//                   onChange={(e) => setBookType(e.target.value)}
//                   size="small"
//                   sx={{ borderRadius: 1 }}
//                 >
//                   <MenuItem value="">
//                     <em>Select Genre</em>
//                   </MenuItem>
//                   {bookTypesData.map((type) => (
//                     <MenuItem key={type.value} value={type.value}>
//                       {type.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid xs={12} md={3}>
//               <Button
//                 variant="outlined"
//                 fullWidth
//                 onClick={() => setOpenSavedDialog(true)}
//                 startIcon={<History sx={{ fontSize: 18 }} />}
//                 size="small"
//                 sx={{ height: "40px", borderRadius: 1 }}
//               >
//                 <Badge
//                   badgeContent={savedContents.length}
//                   color="error"
//                   sx={{ mr: 1 }}
//                 >
//                   Saved
//                 </Badge>
//               </Button>
//             </Grid>

//             <Grid xs={12} md={3}>
//               <Button
//                 variant="contained"
//                 fullWidth
//                 onClick={handleGenerate}
//                 disabled={loading}
//                 startIcon={<RocketLaunch sx={{ fontSize: 18 }} />}
//                 size="small"
//                 sx={{
//                   height: "40px",
//                   borderRadius: 1,
//                   background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 }}
//               >
//                 {loading ? <CircularProgress size={20} /> : "Generate"}
//               </Button>
//             </Grid>
//           </Grid>

//           {/* Active Generator Form */}
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{
//               mb: 2,
//               fontWeight: 600,
//               color: theme.palette.primary.dark,
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             }}
//           >
//             {generators.find((g) => g.id === activeGenerator)?.icon}
//             {generators.find((g) => g.id === activeGenerator)?.label}
//           </Typography>

//           <form onSubmit={handleGenerate}>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               {renderFormFields()}
//             </Grid>
//           </form>

//           {/* Generated Content Editor Section */}
//           {generatedContent && (
//             <Fade in={true}>
//               <Box sx={{ mt: 3 }}>
//                 <Divider sx={{ mb: 2 }}>
//                   <Chip
//                     label="Generated Content Editor"
//                     icon={<EditNote sx={{ fontSize: 14 }} />}
//                     size="small"
//                     sx={{
//                       background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                       color: "white",
//                     }}
//                   />
//                 </Divider>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     background:
//                       theme.palette.mode === "dark"
//                         ? alpha(theme.palette.background.paper, 0.8)
//                         : theme.palette.background.paper,
//                     border: "1px solid",
//                     borderColor:
//                       theme.palette.mode === "dark"
//                         ? theme.palette.divider
//                         : alpha(theme.palette.primary.light, 0.2),
//                     borderRadius: 2,
//                     minHeight: 150,
//                     position: "relative",
//                     boxShadow: `0 4px 20px ${alpha(
//                       theme.palette.primary.main,
//                       theme.palette.mode === "dark" ? 0.15 : 0.08,
//                     )}`,
//                     "&:before": {
//                       content: '""',
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: 4,
//                       background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                       borderTopLeftRadius: 8,
//                       borderTopRightRadius: 8,
//                     },
//                   }}
//                 >
//                   {/* Editor Field */}
//                   <TextField
//                     fullWidth
//                     multiline
//                     rows={10}
//                     value={editedContent}
//                     onChange={(e) => setEditedContent(e.target.value)}
//                     variant="outlined"
//                     sx={{
//                       mb: 2,
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 1,
//                         fontFamily: "'Fira Code', 'Courier New', monospace",
//                         fontSize: "0.875rem",
//                         lineHeight: 1.6,
//                       },
//                     }}
//                     placeholder="Edit your generated content here..."
//                   />

//                   {/* Compact Action Buttons */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       top: 8,
//                       right: 8,
//                       display: "flex",
//                       gap: 0.5,
//                     }}
//                   >
//                     <Tooltip title="Full Screen">
//                       <IconButton
//                         size="small"
//                         onClick={() => setOpenContentDialog(true)}
//                         sx={{
//                           bgcolor: "white",
//                           boxShadow: 1,
//                           color: theme.palette.primary.main,
//                           "&:hover": {
//                             bgcolor: theme.palette.grey[100],
//                             color: theme.palette.primary.dark,
//                           },
//                         }}
//                       >
//                         <Fullscreen sx={{ fontSize: 16 }} />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Copy">
//                       <IconButton
//                         size="small"
//                         onClick={handleCopy}
//                         sx={{ bgcolor: "white", boxShadow: 1 }}
//                       >
//                         <ContentCopy sx={{ fontSize: 16 }} />
//                       </IconButton>
//                     </Tooltip>
//                   </Box>

//                   {/* Compact Action Buttons Row */}
//                   <Stack
//                     direction="row"
//                     spacing={1}
//                     justifyContent="center"
//                     sx={{ mt: 2, flexWrap: "wrap", gap: 1 }}
//                   >
//                     <Button
//                       variant="contained"
//                       size="small"
//                       startIcon={<Save sx={{ fontSize: 16 }} />}
//                       onClick={handleSave}
//                       sx={{
//                         fontSize: "0.75rem",
//                         px: 1.5,
//                         py: 0.5,
//                         background: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
//                         borderRadius: 1,
//                       }}
//                     >
//                       Save
//                     </Button>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       startIcon={<Download sx={{ fontSize: 16 }} />}
//                       onClick={handleDownload}
//                       sx={{
//                         fontSize: "0.75rem",
//                         px: 1.5,
//                         py: 0.5,
//                         background: `linear-gradient(135deg, ${theme.palette.info.main}, ${theme.palette.info.dark})`,
//                         borderRadius: 1,
//                       }}
//                     >
//                       Download
//                     </Button>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       startIcon={<FileCopy sx={{ fontSize: 16 }} />}
//                       onClick={handleCopy}
//                       sx={{
//                         fontSize: "0.75rem",
//                         px: 1.5,
//                         py: 0.5,
//                         background: `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.warning.dark})`,
//                         borderRadius: 1,
//                       }}
//                     >
//                       Copy
//                     </Button>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       startIcon={<Share sx={{ fontSize: 16 }} />}
//                       onClick={handleShare}
//                       sx={{
//                         fontSize: "0.75rem",
//                         px: 1.5,
//                         py: 0.5,
//                         background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`,
//                         borderRadius: 1,
//                       }}
//                     >
//                       Share
//                     </Button>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       startIcon={<SaveAlt sx={{ fontSize: 16 }} />}
//                       onClick={handleExport}
//                       sx={{
//                         fontSize: "0.75rem",
//                         px: 1.5,
//                         py: 0.5,
//                         background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                         borderRadius: 1,
//                       }}
//                     >
//                       Export
//                     </Button>
//                   </Stack>
//                 </Paper>
//               </Box>
//             </Fade>
//           )}
//         </Paper>
//       </Container>

//       {/* Full Screen Content Dialog */}
//       <Dialog
//         open={openContentDialog}
//         onClose={() => setOpenContentDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{ py: 1.5, px: 2 }}>
//           <Stack
//             direction="row"
//             justifyContent="space-between"
//             alignItems="center"
//           >
//             <Typography variant="subtitle1" fontWeight={600}>
//               Full Screen View
//             </Typography>
//             <IconButton
//               onClick={() => setOpenContentDialog(false)}
//               size="small"
//               sx={{
//                 color: theme.palette.error.main,
//                 "&:hover": {
//                   backgroundColor: alpha(theme.palette.error.main, 0.1),
//                 },
//               }}
//             >
//               <Close />
//             </IconButton>
//           </Stack>
//         </DialogTitle>
//         <DialogContent sx={{ py: 1, px: 2 }}>
//           <Paper
//             sx={{
//               p: 2,
//               background: theme.palette.grey[50],
//               borderRadius: 1,
//               maxHeight: "70vh",
//               overflow: "auto",
//             }}
//           >
//             <TextField
//               fullWidth
//               multiline
//               rows={20}
//               value={editedContent}
//               onChange={(e) => setEditedContent(e.target.value)}
//               variant="outlined"
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: 1,
//                   fontFamily: "'Fira Code', 'Courier New', monospace",
//                   fontSize: "0.875rem",
//                   lineHeight: 1.6,
//                 },
//               }}
//             />
//           </Paper>
//         </DialogContent>
//         <DialogActions sx={{ py: 1, px: 2 }}>
//           <Button onClick={handleCopy} startIcon={<ContentCopy />} size="small">
//             Copy
//           </Button>
//           <Button
//             onClick={handleDownload}
//             startIcon={<Download />}
//             size="small"
//           >
//             Download
//           </Button>
//           <Button onClick={handleSave} startIcon={<Save />} size="small">
//             Save
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Saved Contents Dialog */}
//       <Dialog
//         open={openSavedDialog}
//         onClose={() => setOpenSavedDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{ py: 1.5, px: 2 }}>
//           <Stack
//             direction="row"
//             justifyContent="space-between"
//             alignItems="center"
//           >
//             <Typography variant="subtitle1" fontWeight={600}>
//               Saved Contents ({savedContents.length})
//             </Typography>
//             <IconButton
//               onClick={() => setOpenSavedDialog(false)}
//               size="small"
//               sx={{
//                 color: theme.palette.error.main,
//                 "&:hover": {
//                   backgroundColor: alpha(theme.palette.error.main, 0.1),
//                 },
//               }}
//             >
//               <Close />
//             </IconButton>
//           </Stack>
//         </DialogTitle>
//         <DialogContent sx={{ py: 1, px: 2 }}>
//           {savedContents.length === 0 ? (
//             <Box sx={{ textAlign: "center", py: 3 }}>
//               <Typography variant="body2" color="text.secondary">
//                 No saved contents yet. Generate and save some content!
//               </Typography>
//             </Box>
//           ) : (
//             <List dense>
//               {savedContents.map((item) => (
//                 <ListItem
//                   key={item.id}
//                   sx={{
//                     mb: 0.5,
//                     border: "1px solid",
//                     borderColor: theme.palette.grey[200],
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: theme.palette.grey[50],
//                     },
//                   }}
//                   secondaryAction={
//                     <Stack direction="row" spacing={0.5}>
//                       <IconButton
//                         edge="end"
//                         aria-label="view"
//                         onClick={() => handleViewSaved(item)}
//                         size="small"
//                         color="primary"
//                       >
//                         <Visibility sx={{ fontSize: 16 }} />
//                       </IconButton>
//                       <IconButton
//                         edge="end"
//                         aria-label="delete"
//                         onClick={() => handleDeleteSaved(item.id)}
//                         size="small"
//                         color="error"
//                       >
//                         <Delete sx={{ fontSize: 16 }} />
//                       </IconButton>
//                     </Stack>
//                   }
//                 >
//                   <ListItemIcon sx={{ minWidth: 36 }}>
//                     {generators.find((g) => g.id === item.generator)?.icon}
//                   </ListItemIcon>
//                   <ListItemText
//                     primary={
//                       <Typography variant="subtitle2" fontWeight={500}>
//                         {item.title}
//                       </Typography>
//                     }
//                     secondary={
//                       <>
//                         <Typography
//                           component="span"
//                           variant="caption"
//                           color="text.primary"
//                         >
//                           {item.preview}
//                         </Typography>
//                         <br />
//                         <Typography variant="caption" color="text.secondary">
//                           {item.timestamp} • {item.language} • {item.genre}
//                         </Typography>
//                       </>
//                     }
//                   />
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ py: 1, px: 2 }}>
//           <Button
//             onClick={() => {
//               localStorage.removeItem("aiBookSavedContents");
//               setSavedContents([]);
//               showNotification("All saved contents cleared!", "info");
//             }}
//             color="error"
//             startIcon={<Delete />}
//             size="small"
//           >
//             Clear All
//           </Button>
//           <Button
//             onClick={() => {
//               const dataStr = JSON.stringify(savedContents, null, 2);
//               const dataUri =
//                 "data:application/json;charset=utf-8," +
//                 encodeURIComponent(dataStr);
//               const exportFileDefaultName = `ai-book-saved-contents-${Date.now()}.json`;
//               const linkElement = document.createElement("a");
//               linkElement.setAttribute("href", dataUri);
//               linkElement.setAttribute("download", exportFileDefaultName);
//               linkElement.click();
//             }}
//             startIcon={<Download />}
//             size="small"
//           >
//             Export All
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Notification Snackbar */}
//       <Snackbar
//         open={notification.open}
//         autoHideDuration={2000}
//         onClose={() => setNotification({ ...notification, open: false })}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           onClose={() => setNotification({ ...notification, open: false })}
//           severity={notification.severity}
//           variant="filled"
//           sx={{
//             width: "100%",
//             borderRadius: 1,
//             alignItems: "center",
//             boxShadow: 3,
//             "& .MuiAlert-icon": {
//               alignItems: "center",
//             },
//           }}
//         >
//           {notification.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AIBookWriting;



import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Container,
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  Stack,
  Divider,
  IconButton,
  Card,
  CardContent,
  Alert,
  Chip,
  CircularProgress,
  alpha,
  useTheme,
  Fade,
  Zoom,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Badge,
  Snackbar,
  Tooltip,
  Fab,
} from "@mui/material";
import {
  AutoStories,
  FormatListBulleted,
  Image,
  Lightbulb,
  ContentCopy,
  Download,
  Save,
  CheckCircle,
  Language,
  EditNote,
  Psychology,
  Palette,
  DesignServices,
  Dashboard,
  Book,
  Star,
  Bolt,
  RocketLaunch,
  Share,
  Close,
  Fullscreen,
  Visibility,
  Delete,
  FileDownload,
  FileCopy,
  IosShare,
  SaveAlt,
  History,
  Check,
  Expand,
  Launch,
  ArrowDownward,
} from "@mui/icons-material";
import MuiAlert from "@mui/material/Alert";
import { Breadcrumbs, Link } from "@mui/material";
import { Home, ChevronRight } from "@mui/icons-material";
import newBlogService from "../services/new_blogsServices";
import Loader from "../utils/loader"; // Add this import

const AIBookWriting = () => {
  const [activeGenerator, setActiveGenerator] = useState("idea");
  const [language, setLanguage] = useState("english");
  const [bookType, setBookType] = useState("");
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [generatorLoading, setGeneratorLoading] = useState(null); // For individual generator loading
  const [generatedContent, setGeneratedContent] = useState("");
  const [editedContent, setEditedContent] = useState("");
  const [savedContents, setSavedContents] = useState([]);
  const [openContentDialog, setOpenContentDialog] = useState(false);
  const [openSavedDialog, setOpenSavedDialog] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const theme = useTheme();
  const getContent = (res) => res?.data?.content || null;

  useEffect(() => {
    const saved = localStorage.getItem("aiBookSavedContents");
    if (saved) {
      setSavedContents(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("aiBookSavedContents", JSON.stringify(savedContents));
  }, [savedContents]);

  useEffect(() => {
    setEditedContent(generatedContent);
  }, [generatedContent]);

  const generators = [
    {
      id: "idea",
      label: "Book Idea Generator",
      description: "Generate unique book concepts",
      icon: <Lightbulb />,
      color: "warning",
    },
    {
      id: "outline",
      label: "Book Outline Generator",
      description: "Create chapter structures",
      icon: <FormatListBulleted />,
      color: "info",
    },
    {
      id: "cover",
      label: "Book Cover Ideas",
      description: "Design book cover concepts",
      icon: <Palette />,
      color: "success",
    },
    {
      id: "summary",
      label: "Book Summary Generator",
      description: "Craft summaries and synopses",
      icon: <DesignServices />,
      color: "secondary",
    },
  ];

  const languages = [
    { value: "english", label: "English" },
    { value: "tamil", label: "Tamil" },
    { value: "arabic", label: "Arabic" },
    { value: "spanish", label: "Spanish" },
    { value: "french", label: "French" },
    { value: "german", label: "German" },
    { value: "japanese", label: "Japanese" },
    { value: "korean", label: "Korean" },
  ];

  const bookTypesData = [
    { value: "horror", label: "Horror" },
    { value: "fantasy", label: "Fantasy" },
    { value: "romance", label: "Romance" },
    { value: "science", label: "Science Fiction" },
    { value: "thriller", label: "Thriller" },
    { value: "crime", label: "Crime" },
    { value: "action", label: "Action" },
    { value: "historical", label: "Historical" },
  ];

  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const generateBookIdeaFromAPI = async () => {
    if (!formData.bookAbout || !bookType || !formData.category) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("idea"); // Set specific generator loading
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        category: formData.category,
        book_about: formData.bookAbout,
        tone: "Creative",
      };

      console.log("🚀 BOOK IDEA PAYLOAD:", payload);

      const res = await newBlogService.generateBookIdea(payload);

      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error"
        );
        return;
      }

      setGeneratedContent(content);
      setEditedContent(content);
      showNotification("Book idea generated successfully!", "success");

    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book idea", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null); // Reset specific generator loading
    }
  };

  const generateBookCoverFromAPI = async () => {
    if (!formData.title || !formData.author || !formData.summary || !bookType) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("cover"); // Set specific generator loading
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        chapters: formData.chapters || "12",
        book_title: formData.title,
        author_name: formData.author,
        subtitle: formData.subtitle || "",
        brief_summary: formData.summary,
        tone: "Creative",
      };

      console.log("🚀 BOOK COVER PAYLOAD:", payload);

      const res = await newBlogService.generateBookCoverIdeas(payload);

      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error"
        );
        return;
      }

      setGeneratedContent(content);
      setEditedContent(content);
      showNotification("Book cover ideas generated successfully!", "success");

    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book cover ideas", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null); // Reset specific generator loading
    }
  };

  const handleGeneratorClick = (generatorId) => {
    setActiveGenerator(generatorId);
    setFormData({});
    setGeneratedContent("");
    setEditedContent("");
  };

  const handleFormChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const generateBookOutlineFromAPI = async () => {
    if (!formData.title || !formData.chapters || !bookType) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("outline"); // Set specific generator loading
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        chapters: formData.chapters,
        book_title: formData.title,
        target_audience: formData.audience || "General readers",
        tone: "Creative",
      };

      console.log("🚀 BOOK OUTLINE PAYLOAD:", payload);

      const res = await newBlogService.generateBookOutline(payload);

      console.log("✅ BOOK OUTLINE RESPONSE:", res);

      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error"
        );
        return;
      }

      setGeneratedContent(content);
      setEditedContent(content);
      showNotification("Book outline generated successfully!", "success");

    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book outline", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null); // Reset specific generator loading
    }
  };

  const generateBookSummaryFromAPI = async () => {
    if (!formData.bookAbout || !bookType) {
      showNotification("Please fill all required fields!", "warning");
      return;
    }

    try {
      setGeneratorLoading("summary"); // Set specific generator loading
      setLoading(true);

      const payload = {
        language: language.charAt(0).toUpperCase() + language.slice(1),
        book_genre: bookType,
        book_about: formData.bookAbout,
        tone_of_writing: formData.tone || "Dramatic",
      };

      console.log("🚀 BOOK SUMMARY PAYLOAD:", payload);

      const res = await newBlogService.generateBookSummary(payload);

      const content = getContent(res);

      if (!content) {
        showNotification(
          res?.data?.message || "Failed to get content from server",
          "error"
        );
        return;
      }

      setGeneratedContent(content);
      setEditedContent(content);
      showNotification("Book summary generated successfully!", "success");

    } catch (err) {
      console.error(err);
      showNotification("Failed to generate book summary", "error");
    } finally {
      setLoading(false);
      setGeneratorLoading(null); // Reset specific generator loading
    }
  };

  const handleGenerate = async (e) => {
    if (e) e.preventDefault();

    if (activeGenerator === "idea") {
      await generateBookIdeaFromAPI();
    } else if (activeGenerator === "outline") {
      await generateBookOutlineFromAPI();
    } else if (activeGenerator === "cover") {
      await generateBookCoverFromAPI();
    } else if (activeGenerator === "summary") {
      await generateBookSummaryFromAPI();
    } else {
      showNotification("API not connected for this generator yet", "info");
    }
  };

  const handleSave = () => {
    if (!editedContent.trim()) {
      showNotification("No content to save!", "warning");
      return;
    }

    const newContent = {
      id: Date.now(),
      title:
        generators.find((g) => g.id === activeGenerator)?.label || "Untitled",
      content: editedContent,
      generator: activeGenerator,
      language,
      genre: bookType,
      timestamp: new Date().toLocaleString(),
      preview: editedContent.substring(0, 100) + "...",
    };

    const updatedContents = [newContent, ...savedContents];
    setSavedContents(updatedContents);
    showNotification("Content saved successfully!", "success");
  };

  const handleDownload = () => {
    if (!editedContent.trim()) {
      showNotification("No content to download!", "warning");
      return;
    }

    const element = document.createElement("a");
    const file = new Blob([editedContent], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `ai-book-${activeGenerator}-${Date.now()}.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    showNotification("Content downloaded!", "success");
  };

  const handleCopy = () => {
    if (!editedContent.trim()) {
      showNotification("No content to copy!", "warning");
      return;
    }

    navigator.clipboard
      .writeText(editedContent)
      .then(() => showNotification("Content copied to clipboard!", "success"))
      .catch(() => showNotification("Failed to copy content!", "error"));
  };

  const handleShare = () => {
    if (!editedContent.trim()) {
      showNotification("No content to share!", "warning");
      return;
    }

    if (navigator.share) {
      navigator
        .share({
          title: `AI Generated Book ${generators.find((g) => g.id === activeGenerator)?.label}`,
          text: editedContent.substring(0, 100),
          url: window.location.href,
        })
        .then(() => showNotification("Content shared successfully!", "success"))
        .catch(() => showNotification("Share cancelled!", "info"));
    } else {
      handleCopy();
    }
  };

  const handleExport = () => {
    if (!editedContent.trim()) {
      showNotification("No content to export!", "warning");
      return;
    }

    const data = {
      title: generators.find((g) => g.id === activeGenerator)?.label,
      content: editedContent,
      metadata: {
        generator: activeGenerator,
        language,
        genre: bookType,
        timestamp: new Date().toISOString(),
      },
    };

    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });
    element.href = URL.createObjectURL(file);
    element.download = `ai-book-export-${Date.now()}.json`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    showNotification("Content exported as JSON!", "success");
  };

  const handleDeleteSaved = (id) => {
    const updatedContents = savedContents.filter(
      (content) => content.id !== id,
    );
    setSavedContents(updatedContents);
    showNotification("Content deleted!", "success");
  };

  const handleViewSaved = (content) => {
    setGeneratedContent(content.content);
    setEditedContent(content.content);
    setOpenSavedDialog(false);
    showNotification("Content loaded from saved items!", "info");
  };

  const renderFormFields = () => {
    switch (activeGenerator) {
      case "idea":
        return (
          <>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="What is your book about?"
                placeholder="Describe your book idea..."
                multiline
                rows={2}
                value={formData.bookAbout || ""}
                onChange={handleFormChange("bookAbout")}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Category</InputLabel>
                <Select
                  value={formData.category || ""}
                  label="Category"
                  onChange={handleFormChange("category")}
                  required
                  sx={{ borderRadius: 1 }}
                >
                  <MenuItem value="fiction">Fiction</MenuItem>
                  <MenuItem value="non-fiction">Non-Fiction</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </>
        );

      case "outline":
        return (
          <>
            <Grid xs={12} md={4}>
              <TextField
                fullWidth
                type="number"
                label="Chapters"
                value={formData.chapters || ""}
                onChange={handleFormChange("chapters")}
                InputProps={{
                  inputProps: { min: 1, max: 50 },
                }}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                fullWidth
                label="Book Title"
                value={formData.title || ""}
                onChange={handleFormChange("title")}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                fullWidth
                label="Target Audience"
                value={formData.audience || ""}
                onChange={handleFormChange("audience")}
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
          </>
        );

      case "cover":
        return (
          <>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Author's Name"
                value={formData.author || ""}
                onChange={handleFormChange("author")}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <TextField
                fullWidth
                label="Book Title"
                value={formData.title || ""}
                onChange={handleFormChange("title")}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="Subtitle (Optional)"
                value={formData.subtitle || ""}
                onChange={handleFormChange("subtitle")}
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="Brief Summary"
                multiline
                rows={2}
                value={formData.summary || ""}
                onChange={handleFormChange("summary")}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
          </>
        );

      case "summary":
        return (
          <>
            <Grid xs={12}>
              <TextField
                fullWidth
                label="What is your book about?"
                placeholder="Describe your book idea..."
                multiline
                rows={2}
                value={formData.bookAbout || ""}
                onChange={handleFormChange("bookAbout")}
                required
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
            <Grid xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Tone of Writing</InputLabel>
                <Select
                  value={formData.tone || ""}
                  label="Tone of Writing"
                  onChange={handleFormChange("tone")}
                  sx={{ borderRadius: 1 }}
                >
                  <MenuItem value="formal">Formal</MenuItem>
                  <MenuItem value="casual">Casual</MenuItem>
                  <MenuItem value="humorous">Humorous</MenuItem>
                  <MenuItem value="dramatic">Dramatic</MenuItem>
                  <MenuItem value="poetic">Poetic</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: theme.palette.grey[50],
        backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.05)} 0%, ${alpha(theme.palette.secondary.light, 0.05)} 100%)`,
        py: 2,
      }}
    >
      <Container maxWidth="lg" sx={{ py: 1 }}>
        <Box sx={{ mb: 2 }}>
          <Breadcrumbs
            separator={
              <ChevronRight
                fontSize="small"
                sx={{ color: theme.palette.primary.main }}
              />
            }
            aria-label="breadcrumb"
          >
            <Link
              href="/blogpage"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "0.875rem",
                color: theme.palette.primary.main,
                fontWeight: 500,
                "&:hover": {
                  color: theme.palette.primary.dark,
                },
              }}
            >
              <Home sx={{ mr: 0.5, fontSize: 16 }} />
              Blog Page
            </Link>

            <Typography
              sx={{
                fontSize: "0.875rem",
                fontWeight: 600,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              AI Book Writing Assistant
            </Typography>
          </Breadcrumbs>
        </Box>

        {/* Compact Header */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Stack direction="row" spacing={1} justifyContent="center" mb={1}>
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                color: "white",
              }}
            >
              <AutoStories sx={{ fontSize: 40 }} />
            </Box>
          </Stack>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: theme.palette.primary.dark,
              fontSize: { xs: "1.75rem", md: "2.25rem" },
              mb: 0.5,
            }}
          >
            AI Book Writing Assistant
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: theme.palette.text.secondary,
              mb: 2,
              fontWeight: 400,
            }}
          >
            Generate, save, and export your book ideas with AI
          </Typography>
        </Box>

        {/* Main Content Card */}
        <Paper
          elevation={2}
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 3,
            background: "white",
            mb: 3,
            position: "relative",
          }}
        >
          {/* Show loader when loading */}
          {loading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
                borderRadius: 3,
              }}
            >
              <Loader />
            </Box>
          )}

          {/* Generator Selection */}
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              mb: 2,
              fontWeight: 600,
              color: theme.palette.primary.dark,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Dashboard sx={{ fontSize: 20 }} />
            Choose Your AI Generator
          </Typography>

          <Grid container spacing={2} sx={{ mb: 4 }}>
            {generators.map((gen) => (
              <Grid xs={12} sm={6} md={3} key={gen.id}>
                <Card
                  onClick={() => handleGeneratorClick(gen.id)}
                  sx={{
                    cursor: "pointer",
                    height: "100%",
                    transition: "all 0.2s",
                    border: activeGenerator === gen.id ? 2 : 1,
                    borderColor:
                      activeGenerator === gen.id
                        ? `${gen.color}.main`
                        : "divider",
                    position: "relative",
                    overflow: "hidden",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  elevation={activeGenerator === gen.id ? 1 : 0}
                >
                  {/* Individual generator loader overlay */}
                  {generatorLoading === gen.id && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.85)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2,
                      }}
                    >
                      <CircularProgress
                        size={40}
                        sx={{
                          color: theme.palette[gen.color].main,
                        }}
                      />
                    </Box>
                  )}
                  
                  <CardContent sx={{ textAlign: "center", py: 2, px: 1 }}>
                    <Box
                      sx={{
                        color: `${gen.color}.main`,
                        mb: 1,
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    >
                      {gen.icon}
                    </Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      gutterBottom
                    >
                      {gen.label}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {gen.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Compact Settings Row */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <Language sx={{ fontSize: 16 }} />
                    <Typography variant="caption">Language</Typography>
                  </Stack>
                </InputLabel>
                <Select
                  value={language}
                  label="Language"
                  onChange={(e) => setLanguage(e.target.value)}
                  size="small"
                  sx={{ borderRadius: 1 }}
                >
                  {languages.map((lang) => (
                    <MenuItem key={lang.value} value={lang.value}>
                      {lang.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <EditNote sx={{ fontSize: 16 }} />
                    <Typography variant="caption">Book Genre</Typography>
                  </Stack>
                </InputLabel>
                <Select
                  value={bookType}
                  label="Book Genre"
                  onChange={(e) => setBookType(e.target.value)}
                  size="small"
                  sx={{ borderRadius: 1 }}
                >
                  <MenuItem value="">
                    <em>Select Genre</em>
                  </MenuItem>
                  {bookTypesData.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid xs={12} md={3}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setOpenSavedDialog(true)}
                startIcon={<History sx={{ fontSize: 18 }} />}
                size="small"
                sx={{ height: "40px", borderRadius: 1 }}
              >
                <Badge
                  badgeContent={savedContents.length}
                  color="error"
                  sx={{ mr: 1 }}
                >
                  Saved
                </Badge>
              </Button>
            </Grid>

            <Grid xs={12} md={3}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleGenerate}
                disabled={loading}
                startIcon={<RocketLaunch sx={{ fontSize: 18 }} />}
                size="small"
                sx={{
                  height: "40px",
                  borderRadius: 1,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                }}
              >
                {loading ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : (
                  "Generate"
                )}
              </Button>
            </Grid>
          </Grid>

          {/* Active Generator Form */}
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              mb: 2,
              fontWeight: 600,
              color: theme.palette.primary.dark,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {generators.find((g) => g.id === activeGenerator)?.icon}
            {generators.find((g) => g.id === activeGenerator)?.label}
          </Typography>

          <form onSubmit={handleGenerate}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {renderFormFields()}
            </Grid>
          </form>

          {/* Generated Content Editor Section */}
          {generatedContent && (
            <Fade in={true}>
              <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }}>
                  <Chip
                    label="Generated Content Editor"
                    icon={<EditNote sx={{ fontSize: 14 }} />}
                    size="small"
                    sx={{
                      background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                      color: "white",
                    }}
                  />
                </Divider>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    background:
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.background.paper, 0.8)
                        : theme.palette.background.paper,
                    border: "1px solid",
                    borderColor:
                      theme.palette.mode === "dark"
                        ? theme.palette.divider
                        : alpha(theme.palette.primary.light, 0.2),
                    borderRadius: 2,
                    minHeight: 150,
                    position: "relative",
                    boxShadow: `0 4px 20px ${alpha(
                      theme.palette.primary.main,
                      theme.palette.mode === "dark" ? 0.15 : 0.08,
                    )}`,
                    "&:before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                      borderTopLeftRadius: 8,
                      borderTopRightRadius: 8,
                    },
                  }}
                >
                  {/* Editor Field */}
                  <TextField
                    fullWidth
                    multiline
                    rows={10}
                    value={editedContent}
                    onChange={(e) => setEditedContent(e.target.value)}
                    variant="outlined"
                    sx={{
                      mb: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                        fontFamily: "'Fira Code', 'Courier New', monospace",
                        fontSize: "0.875rem",
                        lineHeight: 1.6,
                      },
                    }}
                    placeholder="Edit your generated content here..."
                  />

                  {/* Compact Action Buttons */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      display: "flex",
                      gap: 0.5,
                    }}
                  >
                    <Tooltip title="Full Screen">
                      <IconButton
                        size="small"
                        onClick={() => setOpenContentDialog(true)}
                        sx={{
                          bgcolor: "white",
                          boxShadow: 1,
                          color: theme.palette.primary.main,
                          "&:hover": {
                            bgcolor: theme.palette.grey[100],
                            color: theme.palette.primary.dark,
                          },
                        }}
                      >
                        <Fullscreen sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Copy">
                      <IconButton
                        size="small"
                        onClick={handleCopy}
                        sx={{ bgcolor: "white", boxShadow: 1 }}
                      >
                        <ContentCopy sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  {/* Compact Action Buttons Row */}
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="center"
                    sx={{ mt: 2, flexWrap: "wrap", gap: 1 }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<Save sx={{ fontSize: 16 }} />}
                      onClick={handleSave}
                      sx={{
                        fontSize: "0.75rem",
                        px: 1.5,
                        py: 0.5,
                        background: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
                        borderRadius: 1,
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<Download sx={{ fontSize: 16 }} />}
                      onClick={handleDownload}
                      sx={{
                        fontSize: "0.75rem",
                        px: 1.5,
                        py: 0.5,
                        background: `linear-gradient(135deg, ${theme.palette.info.main}, ${theme.palette.info.dark})`,
                        borderRadius: 1,
                      }}
                    >
                      Download
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<FileCopy sx={{ fontSize: 16 }} />}
                      onClick={handleCopy}
                      sx={{
                        fontSize: "0.75rem",
                        px: 1.5,
                        py: 0.5,
                        background: `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.warning.dark})`,
                        borderRadius: 1,
                      }}
                    >
                      Copy
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<Share sx={{ fontSize: 16 }} />}
                      onClick={handleShare}
                      sx={{
                        fontSize: "0.75rem",
                        px: 1.5,
                        py: 0.5,
                        background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`,
                        borderRadius: 1,
                      }}
                    >
                      Share
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<SaveAlt sx={{ fontSize: 16 }} />}
                      onClick={handleExport}
                      sx={{
                        fontSize: "0.75rem",
                        px: 1.5,
                        py: 0.5,
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        borderRadius: 1,
                      }}
                    >
                      Export
                    </Button>
                  </Stack>
                </Paper>
              </Box>
            </Fade>
          )}
        </Paper>
      </Container>

      {/* Full Screen Content Dialog */}
      <Dialog
        open={openContentDialog}
        onClose={() => setOpenContentDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ py: 1.5, px: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" fontWeight={600}>
              Full Screen View
            </Typography>
            <IconButton
              onClick={() => setOpenContentDialog(false)}
              size="small"
              sx={{
                color: theme.palette.error.main,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ py: 1, px: 2 }}>
          <Paper
            sx={{
              p: 2,
              background: theme.palette.grey[50],
              borderRadius: 1,
              maxHeight: "70vh",
              overflow: "auto",
            }}
          >
            <TextField
              fullWidth
              multiline
              rows={20}
              value={editedContent}
              onChange={(e) => setEditedContent(e.target.value)}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1,
                  fontFamily: "'Fira Code', 'Courier New', monospace",
                  fontSize: "0.875rem",
                  lineHeight: 1.6,
                },
              }}
            />
          </Paper>
        </DialogContent>
        <DialogActions sx={{ py: 1, px: 2 }}>
          <Button onClick={handleCopy} startIcon={<ContentCopy />} size="small">
            Copy
          </Button>
          <Button
            onClick={handleDownload}
            startIcon={<Download />}
            size="small"
          >
            Download
          </Button>
          <Button onClick={handleSave} startIcon={<Save />} size="small">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Saved Contents Dialog */}
      <Dialog
        open={openSavedDialog}
        onClose={() => setOpenSavedDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ py: 1.5, px: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" fontWeight={600}>
              Saved Contents ({savedContents.length})
            </Typography>
            <IconButton
              onClick={() => setOpenSavedDialog(false)}
              size="small"
              sx={{
                color: theme.palette.error.main,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ py: 1, px: 2 }}>
          {savedContents.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <Typography variant="body2" color="text.secondary">
                No saved contents yet. Generate and save some content!
              </Typography>
            </Box>
          ) : (
            <List dense>
              {savedContents.map((item) => (
                <ListItem
                  key={item.id}
                  sx={{
                    mb: 0.5,
                    border: "1px solid",
                    borderColor: theme.palette.grey[200],
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: theme.palette.grey[50],
                    },
                  }}
                  secondaryAction={
                    <Stack direction="row" spacing={0.5}>
                      <IconButton
                        edge="end"
                        aria-label="view"
                        onClick={() => handleViewSaved(item)}
                        size="small"
                        color="primary"
                      >
                        <Visibility sx={{ fontSize: 16 }} />
                      </IconButton>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => handleDeleteSaved(item.id)}
                        size="small"
                        color="error"
                      >
                        <Delete sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Stack>
                  }
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    {generators.find((g) => g.id === item.generator)?.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle2" fontWeight={500}>
                        {item.title}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="caption"
                          color="text.primary"
                        >
                          {item.preview}
                        </Typography>
                        <br />
                        <Typography variant="caption" color="text.secondary">
                          {item.timestamp} • {item.language} • {item.genre}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions sx={{ py: 1, px: 2 }}>
          <Button
            onClick={() => {
              localStorage.removeItem("aiBookSavedContents");
              setSavedContents([]);
              showNotification("All saved contents cleared!", "info");
            }}
            color="error"
            startIcon={<Delete />}
            size="small"
          >
            Clear All
          </Button>
          <Button
            onClick={() => {
              const dataStr = JSON.stringify(savedContents, null, 2);
              const dataUri =
                "data:application/json;charset=utf-8," +
                encodeURIComponent(dataStr);
              const exportFileDefaultName = `ai-book-saved-contents-${Date.now()}.json`;
              const linkElement = document.createElement("a");
              linkElement.setAttribute("href", dataUri);
              linkElement.setAttribute("download", exportFileDefaultName);
              linkElement.click();
            }}
            startIcon={<Download />}
            size="small"
          >
            Export All
          </Button>
        </DialogActions>
      </Dialog>

      {/* Fixed Notification Snackbar without background code */}
      <Snackbar
        open={notification.open}
        autoHideDuration={2000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 0,
          },
        }}
      >
        <MuiAlert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          variant="filled"
          elevation={6}
          sx={{
            width: "100%",
            minWidth: "300px",
            alignItems: "center",
            fontWeight: 500,
            fontSize: "0.875rem",
            "& .MuiAlert-icon": {
              alignItems: "center",
            },
          }}
        >
          {notification.message}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
};

export default AIBookWriting;